import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./Education.css";

const degrees = [
  {
    degree: "Master of Engineering in Computer Science and Engineering",
    school: "University of Louisville, J.B. Speed School of Engineering",
    location: "Louisville, KY",
    dates: "January 2024 – December 2025",
    coursework: ["Information Security", "Network Security", "Artificial Intelligence"],
    award:
      "John H. Simester Award for Academic Excellence, Department of Computer Science and Engineering, April 2025",
  },
  {
    degree: "Bachelor’s degree in Computer Science and Engineering",
    school: "University of Louisville, J.B. Speed School of Engineering",
    location: "Louisville, KY",
    dates: "May 2019 – May 2023",
    coursework: ["Operating Systems", "Networking Fundamentals", "Software Engineering"],
  },
];

class Education extends Component {
  render() {
    return (
      <div className="Page">
        <div className="PageContainer">
          <h1 className="PageHeading">Education</h1>
          <div className="DegreeList">
            {degrees.map((d) => (
              <section className="Card DegreeCard" key={d.degree}>
                <h2 className="DegreeTitle">{d.degree}</h2>
                <p className="DegreeSchool">{d.school}</p>
                <p className="DegreeMeta">
                  <span>{d.location}</span>
                  <span aria-hidden="true"> · </span>
                  <span>{d.dates}</span>
                </p>
                <p className="DegreeDetail">
                  <strong>Relevant coursework:</strong> {d.coursework.join(", ")}
                </p>
                {d.award && (
                  <p className="DegreeDetail">
                    <strong>Award:</strong> {d.award}
                  </p>
                )}
              </section>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default Education;
